import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the ConfigProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ConfigProvider {


  tipo_spinner = "ball-spin";

  ///////////Login -- Snappc///////////////////////////////////////////////

  img_ancho = "380px";
  img_alto = "115px";
  fondo_login = "#282a2a";
  linea_debajo_del_logo_fondo = "#1490b7";
  color_border_input_user_user = "#0e3d5e";   /////////////
  color_border_input_user_pass = "#0e3d5e";   ////////////
  lbl_titulos_color = "#ffffff";
  btn_login_fondo = "#bb4f07";
  btn_login_color = "#ffffff";

  ////////////////  btn aceptar y canclar  /////////////////////////////////////////////////

  btn_aceptar = "#bb4f07";  // color de fondo de todos los botenes de confirmacion
  btn_aceptar_color = "#ffffff";
  btn_cancelar = "#1490b7";
  btn_cancelar_color = "#ffffff";

  /////////////////////    Modal autorizar   //////////////////////////////////////////////

  color_lbl_titulo_pass = "#ffffff";
  btn_aceptar_color_modal_pass = "#ffffff";
  btn_aceptar_fondo_modal_pass = "#bb4f07";
  color_titulo_config = "#ffffff";
  ver_color_lateral = "#2d2e2e";

  /////////////////////////////////////////////////////////////////////////////////////////
  btn_fondo_modal_fecha = "#bb4f07";


  color_border_txt_agregar_datos = "#000000";
  color_titulo_agregar_datos = "#ffffff";
  fondo_heders_agregar_datos = "#bb4f07";

  constructor(public http: HttpClient) {

  }

}



// WEBPACK FOOTER //
// ./src/providers/config/config.ts